module.exports = __webpack_public_path__ + "img/fortnox.b249dadb.png";